import { Button } from "@/components/ui/button";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "../../ui/dropdown-menu";
import IconProvider from "@/components/ui/IconProvider";

interface ListDropdownProps {
  onFormat: (command: string, value?: string) => void;
}

const listOptions = [
  { value: 'insertUnorderedList', label: 'Bullet List' },
  { value: 'insertOrderedList', label: 'Numbered List' },
];

export const ListDropdown = ({ onFormat }: ListDropdownProps) => {
  const handleListSelect = (value: string) => {
    onFormat(value);
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          variant="ghost"
          size="sm"
          className="h-8 px-2 hover:bg-gray-100 text-gray-700 hover:text-gray-900"
        >
          <div className="flex flex-col gap-0.5">
            <div className="flex items-center gap-1">
              <div className="w-1 h-1 bg-current rounded-full"></div>
              <div className="w-2 h-0.5 bg-current"></div>
            </div>
            <div className="flex items-center gap-1">
              <div className="w-1 h-1 bg-current rounded-full"></div>
              <div className="w-2 h-0.5 bg-current"></div>
            </div>
          </div>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="start" className="w-48">
        {listOptions.map((option) => (
          <DropdownMenuItem
            key={option.value}
            onClick={() => handleListSelect(option.value)}
            className="text-sm"
          >
            {option.label}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}; 